import type { ReactNode } from "react";
import { FormField, type FormFieldWidth } from "./FormField";
import type { FieldHelpDisplay } from "./FieldHelp";

/**
 * Label + help + error frame for an arbitrary control (SelectField,
 * SearchableSelect, DatePicker, SensitiveField). Thin alias over FormField
 * kept for the many existing call sites; new code can use FormField directly.
 */
export function FieldWrap({
  id,
  label,
  required,
  sensitive,
  hint,
  helpDisplay,
  error,
  width,
  children,
}: {
  id: string;
  label: string;
  required?: boolean;
  sensitive?: boolean;
  hint?: string;
  helpDisplay?: FieldHelpDisplay;
  error?: string;
  width?: FormFieldWidth;
  children: ReactNode;
}) {
  return (
    <FormField
      id={id}
      label={label}
      required={required}
      sensitive={sensitive}
      hint={hint}
      helpDisplay={helpDisplay}
      error={error}
      width={width}
    >
      {children}
    </FormField>
  );
}
